import { TimeRegistrationMenu as TimeRegistrationMenuV1 } from 'app/menu/components/TopBarV1/TimeRegistration'

export const TimeRegistrationMenu = TimeRegistrationMenuV1
export default TimeRegistrationMenu
